<div class="container">
  <div class="header text-center">
    <h1>Edit Child Highlight</h1>
  </div>
  <div class="row">
    <!--{{data.highlight|prettyjson}}-->
    <mat-form-field appearance="outline">
      <mat-label>Highlight</mat-label>
      <mat-select [(value)]="data.highlight.highlight">
        <mat-option *ngFor="let h of highlighTypeList$|async" [value]="h">{{ h }}</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="col-md-12">
<!--      <p-editor [(ngModel)]="data.highlight.narrative" [style]="{ height: '250px' }"></p-editor>-->
      <ckeditor
        [editor]="Editor"
        [(ngModel)]="data.highlight.narrative"
        style="height: 300px"
      ></ckeditor>
    </div>


  </div>
  <div class="d-flex justify-content-center m-3">
    <button mat-raised-button  color="primary" (click)="save()">Update</button>
  </div>

</div>
